export let tabs = [
  { title: "data pemeriksaan", link: "pemeriksaan", active: true },
  { title: "data tindakan", link: "tindakan" },
  { title: "resep", link: "resep" }
];
export let data = {
  title: "Detail Rawat Jalan",
  backBtn: "/ralan",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Jalan", link: "/ralan" },
    { title: "Detail Rawat Jalan", active: true }
  ]
};

export let longText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align a the freshlybrewed he clues and we joke. Pay why are expected return house. handed on align a the freshlybrewed he clues and we joke.";
export let veryLongText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align a the freshlybrewed he clues and we joke. Pay why are expected return house. handed on align a the freshlybrewed he clues and we joke.Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills. Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills";
export let mediumText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align.";
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "apps",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 Perumnas Depok I Kel. Depok Jaya, Kec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};
export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      {
        label: "No. Registrasi   |    No. Rawat",
        content: "001  |   2020/04/16/000001",
        icon: "apps"
      },
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      { label: "Unit", content: "MAT | Poliklinik Mata", icon: "apps" },
      { label: "Jenis Periksa", content: "Kunjungan Pasien", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "Dokter yang Dituju",
        content: "D00000026  |   dr. Azizah Masthura",
        icon: "apps"
      }
    ]
  }
];

export let detailRightTop = [
  { label: "Metode Pembayaran", content: "BPJS", icon: "apps" },
  { label: "Nomor Peserta BPJS", content: "00000134786000", icon: "apps" },
  {
    label: "Asal Rujukan",
    content: "Rumah Sakit Mitra Keluarga Depok",
    icon: "apps"
  }
];

export let dataPetugasLeft = [
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      },
      {
        label: "Perawat Pemeriksa",
        content: "P00001  |  Anggriani Ginting",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "tanda vital", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "suhu badan", content: "37 C", icon: "apps" },
      { label: "tekanan darah", content: "120/80 mmHg", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "nadi", content: "75x/menit", icon: "apps" },
      { label: "respirasi", content: "60x/menit", icon: "apps" },
      { label: "gdse", content: "135mg/dL", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "skrining gizi", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "berat badan", content: "75 kg", icon: "apps" },
      { label: "tinggi badan", content: "180 cm", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "fungsional", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "alat bantu",
        content: "alat bantu jalan,alat bantu pendengaran",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      { label: "prothesa", content: "kaki palsu,gigi palsu", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "cacat tubuh",
        content: "cacat pada kaki bagian bawah,cacat pada gigi",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [{ label: "ADL", content: "Mandiri", icon: "apps" }]
  }
];
export let dataPetugasRight = [
  { label: "RPD", content: longText, icon: "" },
  { label: "STATUS ALERGI", labelClass: "text-primary" },
  { label: "Obat", content: "Tidak memiliki alergi", icon: "apps" },
  { label: "Makanan", content: "Keju,Ikan,Udang,Telur Ayam", icon: "apps" },
  { label: "SKRINING RESIKO JATUH DAN CEDERA", labelClass: "text-primary" },
  {
    label:
      "a. Cara jalan pasien saat akan duduk di kursi  tampak tidak seimbang (sempoyongan/limbung)",
    content: "Ya",
    icon: "",
    labelClass: "text-lowercase text-info"
  },
  {
    label: "b. Pasien memegang pinggiran kursi/meja/benda lain saat akan duduk",
    content: "Ya",
    icon: "",
    labelClass: "text-lowercase text-info"
  },
  {
    label: "Hasil",
    content: "Resiko Tinggi ( Ditemukan a dan b )",
    icon: "apps"
  },
  { label: "Skala Nyeri", content: "4 dari 10 ( nyeri sedang )", icon: "apps" }
];
export let dataOphthalmic = [
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      },
      {
        label: "Perawat Pemeriksa",
        content: "P00001  |  Anggriani Ginting",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [{ label: "Keluhan Pasien", content: longText }]
  }
];
export let dataDokterLeft = [
  {
    label: "Tanggal/Waktu Periksa",
    content: "16 April 2020 Jam 14:35",
    icon: "apps"
  },
  { label: "Pemeriksaan Fisik", content: veryLongText }
];
export let dataDokterRight = [
  { label: "Dx Utama", content: mediumText },
  { label: "Dx Sekunder", content: mediumText },
  { label: "Penatalaksanaan Medis", content: mediumText }
];
export let subheader = {
  title: "Sub Employees",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "New Sub Employee",
      link: "#modalFormSubEmployee",
      iconLeft: "add",
      type: "modal"
    }
  ]
};
export let detailBottom = {
  subheader: subheader,
  tabs: [],
  sort: [],
  filters: []
};
export let detailApproval = {
  label: "Rawat Jalan Request Approval",
  placeholder: "Add notes about approval here",
  name: "approval_note",
  value: "",
  actionApprove: "/ralan/approve/1",
  labelApprove: "APPROVE CRUD",
  actionReject: "/ralan/reject/1",
  labelReject: "REJECT",
  approvedDays: { label: "Approved Days", name: "days_approved", value: 3 }
};
